<script setup lang="ts">
import SidePanel from "@/components/SidePanel/SidePanel.vue";
import SidePanelContent from "@/components/SidePanel/SidePanelContent.vue";
import IconButton from "@/components/ui/IconButton/IconButton.vue";
import SvgIcon from "@/components/ui/SvgIcon/SvgIcon.vue";
import { useSightlineStore } from "@/store/sightline";

import SightlineChat from "./SightlineChat.vue";

const sightlineStore = useSightlineStore();

function handleClose(explicit: boolean) {
  if (explicit) {
    sightlineStore.close();
  } else {
    sightlineStore.toggle(false);
  }
}
</script>

<template>
  <div id="sightline_panel" class="sightline-panel" data-ignore-click @click.stop>
    <SidePanel
      side="right"
      :active="sightlineStore.isOpen"
      name="sightline"
      resizable
      push-board
      @close="handleClose"
    >
      <SidePanelContent v-focus-trap :title="$t('sightline.title')">
        <template #title-icon>
          <SvgIcon name="general/sightline" width="16" height="16" />
        </template>
        <template #header-actions>
          <div class="actions">
            <IconButton
              icon="general/new-chat"
              :text="$t('sightline.newChat')"
              @click="sightlineStore.reset"
            />
            <IconButton
              icon="system/minimize"
              :text="$t('sightline.minimize')"
              @click="sightlineStore.toggle(false)"
            />
          </div>
          <span class="divider" aria-hidden="true" />
        </template>
        <SightlineChat />
      </SidePanelContent>
    </SidePanel>
  </div>
</template>

<style lang="scss" scoped>
@use "@/styles/variables/colors";
@use "@/styles/z-index";

.sightline-panel {
  position: relative;
  z-index: z-index.$menu;

  .actions {
    display: flex;
  }

  .divider {
    width: 1px;
    height: 12px;
    border-radius: 30px;
    background: colors.$border-light;
  }
}
</style>
